import '@/app/app.css';
import './category.css';

import '@/app/app';

import { Gallery } from '@/features/gallery/gallery';
import { initSmartSticky } from '@/features/category/category-aside/smart-sticky';
import { CategoryViewSwitcher } from '@/features/category/category-view-switcher/category-view-switcher';
import { CategoryCards } from '@/components/card/card-category/category-cards';
import { CardProductGallery } from '@/components/card/card-product/card-product-gallery';
import { ProcurementsCarousel } from '@/features/section/section-procurements/procurements-carousel';
import { PriceRange } from '@/shared/common/price-range/price-range';

document.addEventListener('DOMContentLoaded', () => {
	initSmartSticky();

	const priceRange = document.querySelector('.js-price-range');
	priceRange && new PriceRange(priceRange);

	new CategoryViewSwitcher('.js-category-view-switcher', '.category-products__cards');

	const categoryCards = document.querySelector('.js-category-cards');
	categoryCards && new CategoryCards(categoryCards);

	const gallery = document.querySelector('.js-gallery');
	gallery && new Gallery(gallery);

	const cardProductGalleries = document.querySelectorAll('.js-card-product-gallery');
	cardProductGalleries.forEach((gallery) => new CardProductGallery(gallery));

	const procurementsCarousels = document.querySelectorAll('.js-procurements-carousel');
	procurementsCarousels.forEach((carousel) => new ProcurementsCarousel(carousel));
});
